import React, { ReactElement, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import { ShellThemeProvider } from '@sede-enterprise/shell-ds-react-framework';
import routepaths from './router/routepaths';
import Router from './router/Router';
import { IFullState } from './types/All.type';
import { AxiosInterceptor, shouldRefreshAccessToken } from './services/GenesisApi';
import getAccessTokenFromCodeRefreshToken from './utils/auth/getAccessTokenFromCodeRefreshToken';
import { userRoleActions } from './store/reducers/GenesisUser';
import { INTERVAL_TIME_60000 } from './constants/Common';

function App(): ReactElement {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isDark } = useSelector((state: IFullState) => state.Theme);

  //  Code to fetch the access token and user details from the refresh token
  useEffect(() => {
    const refreshAccessToken = async () => {
      const refreshToken = sessionStorage.getItem('refresh_token');
      if (!refreshToken) {
        return;
      }
      const { user, accessToken, error } = await getAccessTokenFromCodeRefreshToken(refreshToken);
      if (error) {
        sessionStorage.setItem(
          'redirectPath',
          `${location.pathname}${location.search}${location.hash}`,
        );
        navigate(routepaths.login);
      } else if (user) {
        const userObj = {
          sn: user.sn,
          givenName: user.givenName,
          uid: user.uid,
          accessToken,
          mail: user.mail,
        };
        dispatch(userRoleActions.setNameAccessToken(userObj));
      }
    };

    const interval = setInterval(() => {
      if (shouldRefreshAccessToken()) {
        refreshAccessToken();
      }
    }, INTERVAL_TIME_60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <ShellThemeProvider theme={isDark ? 'dark' : 'light'}>
      <AxiosInterceptor>
        <Router />
      </AxiosInterceptor>
    </ShellThemeProvider>
  );
}

export default App;
